import React, { useEffect, useMemo, useState, useRef } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import SearchIcon from "@mui/icons-material/Search";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import SendIcon from "@mui/icons-material/Send";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ReviewDocumentModel from "./updatedocuments/reviewDocumentModal";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import CloseIcon from "../../assets/crossIcon.svg";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";
import { PreinitiateServices } from "../../services/PreinitiateServices";
import { last } from "pdf-lib";
import { CaseServices } from "../../services/CaseServices";

const SECTION_KEYS = [
  { key: "ADMISSION", label: "ADMISSION" },
  { key: "ENHANCEMENT", label: "ENHANCEMENT" },
  { key: "DISCHARGE", label: "CLAIM" },
  { key: "MAPPED", label: "MAPPED" },
];

function formatCategoryLabel(key) {
  if (!key) return "";
  return key
    .replace(/(DOCUMENT)/, " Documents")
    .replace(/(ONDISCHARGE)/, "Discharge/Claim")
    .replace(/(DURINGTREATMENT)/, "Enhancement")
    .replace(/(ADMISSION)/, "Admission");
}

export default function QueryTmsDocumentModal({
  open,
  onClose,
  initialDocument,
  mappedDocuments,
  caseId,
  latestStageDocuments,
  getMappedDocuments,
  getLatestCaseStage,
  referenceTab,
}) {
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [navSearch, setNavSearch] = useState("");
  const [isReferenceSelected, setReferenceSelected] = useState(false);

  const [expanded, setExpanded] = useState({
    ADMISSION: latestStageDocuments?.[0]?.documentType?.includes("ADMISSION")
      ? true
      : false,
    ENHANCEMENT: latestStageDocuments?.[0]?.documentType?.includes(
      "ENHANCEMENT",
    )
      ? true
      : false,
    DISCHARGE: latestStageDocuments?.[0]?.documentType?.includes("DISCHARGE")
      ? true
      : false,
    // MAPPED: true,
  });
  const [referenceDocuments, setReferenceDocuments] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const docTypeRef = useRef(null);
  const getReferenceDocuments = async (
    image,
    setSelectedImg,
    documentType,
    setDocDetails,
  ) => {
    try {
      const res = await PreinitiateServices?.getReferenceDocuments(
        caseId,
        documentType,
      );
      setReferenceDocuments(res?.data);
      setSelectedDoc({ documenturlmasters: res?.data });
      setDocDetails({ documenturlmasters: res?.data });
      if (setSelectedImg) {
        setSelectedImg({ idx: image?.idx, ...res?.data[image.idx] });
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleMapDocument = async (
    image,
    setSelectedImg,
    docDetails,
    setDocDetails,
  ) => {
    const selectedDocs = docDetails?.documenturlmasters?.filter(
      (item) => item.selected,
    );
    if (!selectedDocs.length) {
      window.alert("Please select documents before proceeding");
      return;
    }

    try {
      if (selectedDocument?.id === selectedDoc?.id) {
        window.alert("Images already mapped with the selected document");
        return;
      }
      const filterNonMappedImages = selectedDocs?.filter((image) => {
        if (!image?.mappedWith) return true;
        return !image.mappedWith.includes(`${selectedDocument?.id}`);
      });

      if (!filterNonMappedImages.length) {
        window.alert("Images already mapped with the selected document");
        return;
      }

      const data = filterNonMappedImages?.map((image, idx) => {
        return {
          sequence: selectedDocument?.documenturlmasters?.length + 1 + idx,
          documentUrl: image?.documentUrl,
        };
      });
      const response = await CaseServices.saveDocumentUrl(
        selectedDocument.id,
        data,
        false,
        true,
      );
      window.alert(response.data.message);

      // Update status of mapped images

      const statusPayload = filterNonMappedImages?.map((image, idx) => {
        return {
          documentId: image?.id,
          status: "MAPPED",
          mappedWith: selectedDocument.id,
        };
      });
      await PreinitiateServices.updateReferenceDocumentStatus(
        statusPayload,
        caseId,
      );
      await getLatestCaseStage();
      await getMappedDocuments();
      await getReferenceDocuments(image, setSelectedImg, "", setDocDetails);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  useEffect(() => {
    if (open && initialDocument) {
      setSelectedDoc(initialDocument);
    }
    if (!open) {
      setSelectedDoc(null);
      setNavSearch("");
    }
  }, [open, initialDocument?.id]);

  // useEffect(() => {
  //   if (referenceTab) {
  //     getReferenceDocuments("", "", `${latestStageDocuments[0]?.documentType}`);

  //     // Force open the correct accordion based on the document type
  //     const docType =
  //       latestStageDocuments?.[0]?.documentType?.toUpperCase() || "";
  //     setExpanded({
  //       ADMISSION: docType.includes("ADMISSION"),
  //       ENHANCEMENT: docType.includes("ENHANCEMENT"),
  //       DISCHARGE: docType.includes("DISCHARGE"),
  //     });
  //   }
  // }, [referenceTab, latestStageDocuments?.[0]?.documentType]);
  useEffect(() => {
    if (referenceTab && latestStageDocuments?.[0]?.documentType) {
      // Only run if docType actually changed
      const docType = latestStageDocuments[0].documentType;
      if (docTypeRef.current === docType) return; // ✅ prevent re-run
      docTypeRef.current = docType;

      getReferenceDocuments("", "", docType);
      setExpanded({
        ADMISSION: docType.toUpperCase().includes("ADMISSION"),
        ENHANCEMENT: docType.toUpperCase().includes("ENHANCEMENT"),
        DISCHARGE: docType.toUpperCase().includes("DISCHARGE"),
      });
    }

    if (!referenceTab) {
      docTypeRef.current = null; // reset when modal closes
    }
  }, [referenceTab, latestStageDocuments?.[0]?.documentType]);

  const filteredGroups = useMemo(() => {
    if (!mappedDocuments?.length) return [];
    const q = navSearch.trim().toLowerCase();
    return mappedDocuments
      .map((group) => {
        const value = (group.value || []).filter(
          (d) =>
            d?.documenturlmasters?.length > 0 &&
            (!q || (d.documentName || "").toLowerCase().includes(q)),
        );
        return { ...group, value };
      })
      .filter((group) => group.value.length > 0); // 🔥 important
  }, [mappedDocuments, navSearch]);

  if (!open) return null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="query-tms-doc-modal-title"
      sx={{
        zIndex: 1300,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: { xs: "95%", sm: "95%", xl: "95%", "2xl": "95%" },
          height: { xs: "95%", sm: "95%", xl: "95%", "2xl": "95%" },

          bgcolor: "background.paper",
          // bgcolor: "red",
          borderRadius: "32px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          outline: "none",
          boxShadow: 24,
        }}
      >
        <div className="flex shrink-0 items-center justify-between border-b border-[#E4E4E4] pl-[16px] xl:pl-[16px] 2xl:pl-[30px] 3xl:pl-[30px] pr-[16px] 2xl:pr-[30px] 3xl:pr-[30px] pt-[27.25px] xl:pt-[27.25px] 2xl:pt-[35.25px] 3xl:pt-[35.25px] pb-[16px]">
          <div
            id="query-tms-doc-modal-title"
            className="font-[Lufga] font-normal text-[28px] xl:text-[32px] 2xl:text-[40px] 3xl:text-[40px] leading-[110%] -tracking-[0.07em] text-[#191919] break-words whitespace-normal max-w-[90%]"
          >
            {selectedDoc?.documentName || "Document Name"}
          </div>

          <div className="flex items-center">
            {/* <FileDownloadOutlinedIcon sx={{ fontSize: 40 }} />{" "} */}
            <div onClick={onClose}>
              {/* <span className="text-2xl leading-none">×</span> */}
              <img
                src={CloseIcon}
                alt="close-icon"
                style={{ width: "42px", height: "42px" }} // adjust size as needed
              />{" "}
            </div>
          </div>
        </div>

        <div className="flex min-h-0 min-w-0 flex-1 flex-col md:flex-row ">
          <aside className="flex max-h-[40vh]  shrink-0 flex-col md:max-h-none md:w-[280px] md:border-r">
            <div className="pl-[16px] pb-[4px] xl:pb-[4px] 2xl:pb-[8px] 3xl:pb-[8px] xl:pl-[16px] 2xl:pl-[30px] 3xl:pl-[30px] pt-[8px] xl:pt-[8px] 2xl:pt-[16px] 3xl:pt-[16px] pr-2">
              <div className="relative  flex items-center w-full h-[47px] gap-[8px] rounded-[30px] border border-solid border-[#000000] px-[16px] py-[12px]">
                <SearchIcon
                  sx={{ fontSize: 30, color: "#797979", pointerEvents: "none" }}
                />

                <input
                  type="search"
                  placeholder="Search Anything"
                  value={navSearch}
                  onChange={(e) => setNavSearch(e.target.value)}
                  // style={{ position: "relative", zIndex: 9999 }}
                  className="flex-1 min-w-0 border-0 bg-transparent outline-none font-[Lufga] font-normal text-[12px]"
                />
              </div>
            </div>
            <nav className="min-h-0 flex-1 overflow-y-auto pl-[16px] xl:pl-[16px] 2xl:pl-[30px] 3xl:pl-[30px] pt-[4px] xl:pt-[4px] 2xl:pt-[8px] 3xl:pt-[4px] pb-2 pr-2">
              {" "}
              {SECTION_KEYS.map(({ key, label }) => {
                // const group = filteredGroups.find((g) => g.key === key);
                const group = filteredGroups.filter((g) => {
                  const k = g.key.toUpperCase();

                  if (key === "ADMISSION") return k.includes("ADMISSION");
                  if (key === "ENHANCEMENT")
                    return (
                      k.includes("ENHANCEMENT") || k.includes("DURINGTREATMENT")
                    );
                  if (key === "DISCHARGE")
                    return k.includes("DISCHARGE") || k.includes("ONDISCHARGE");
                  return false;
                });
                // const items = group?.value || [];
                const items = group.flatMap((g) => g.value || []);
                const isOpen = expanded[key];
                if (items.length === 0) return;
                return (
                  <div
                    key={key}
                    className="pt-[4px] xl:pt-[4px] 2xl:pt-[8px] 3xl:pt-[8px]"
                  >
                    {" "}
                    <div
                      className={`w-full rounded-[26px] overflow-hidden border border-solid border-black ${isOpen ? "bg-[#000000]" : "bg-[#FFFFFF]"}`}
                    >
                      <button
                        type="button"
                        onClick={() => {
                          setExpanded((prev) => ({
                            ...prev,
                            [key]: !prev[key],
                          }));
                          setReferenceSelected(false);
                        }}
                        className={`flex items-center justify-between w-full h-[36px] border-none rounded-[26px] px-[18px] gap-[10px] ${isOpen ? "bg-[#000000]" : "bg-[#FFFFFF]"}`}
                      >
                        <span
                          className={`font-[Lufga] font-medium text-[9.13px] leading-[11.41px] tracking-[-0.38px] uppercase ${isOpen ? "text-[#FFFFFF]" : "text-[#191919]"}`}
                        >
                          {label}
                        </span>

                        <ExpandMoreIcon
                          sx={{
                            fontSize: 22,
                            color: isOpen ? "#FFFFFF" : "#191919",
                            transform: isOpen
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      </button>

                      {isOpen && items.length > 0 && (
                        <div className="pt-[6px]">
                          <hr className="border border-solid border-[#797979]" />
                          <ul className="bg-[#000000] px-[18px] pb-[12px]">
                            {items.map((doc) => (
                              <li key={doc.id} className="list-none pt-[10px]">
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSelectedDoc(doc);
                                    // setReferenceSelected(false);
                                  }}
                                  className={`w-full text-left ${doc?.status === "APPROVED" ? "text-[#68FF9F]" : doc?.status === "REJECTED" ? "text-[#FF4343]" : "text-white"} bg-black border-none outline-none font-[Lufga] ${selectedDoc?.id === doc?.id ? "text-[16px] xl:text-[18px] font-medium" : "text-[12px] xl:text-[14px] font-normal"}  leading-[100%] tracking-[-0.07em]`}
                                >
                                  {doc.documentName}
                                </button>
                              </li>
                            ))}
                            <li className="list-none pt-[10px]">
                              <button
                                type="button"
                                onClick={() => {
                                  // setSelectedDoc(doc);
                                  // setReferenceSelected(false);
                                  getReferenceDocuments(
                                    "",
                                    "",
                                    `${key}DOCUMENT`,
                                  );
                                }}
                                className="w-full text-left text-white bg-black border-none outline-none font-[Lufga] text-[13px] xl:text-[14px] leading-[100%] tracking-[-0.07em]"
                              >
                                Reference Documents
                              </button>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
              {filteredGroups.length === 0 && (
                <p className="px-2 text-sm text-[#797979]">No categories</p>
              )}
              {/* <div
                onClick={() => {
                  setSelectedDoc({ documenturlmasters: referenceDocuments });
                  setReferenceSelected(true);
                  setExpanded({
                    ADMISSION: false,
                    ENHANCEMENT: false,
                    DISCHARGE: false,
                    MAPPED: false,
                  });
                }}
                className={`mt-3 w-full h-[36px] rounded-[26px] border border-solid border-black ${isReferenceSelected ? "bg-[#000000] text-white" : "bg-[#FFFFFF] text-black"} flex items-center justify-between px-[18px] cursor-pointer transition-all duration-200 hover:bg-black group`}
              >
                <span className="font-[Lufga] font-medium text-[9.13px] leading-[11.41px] tracking-[-0.38px] uppercase text-[#191919] group-hover:text-white">
                  Reference Documents
                </span>
              </div> */}
            </nav>
          </aside>{" "}
          <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
            {" "}
            {selectedDoc?.documenturlmasters?.length > 0 ? (
              <ReviewDocumentModel
                key={`${selectedDoc?.id || "doc"}-${selectedDoc?.documenturlmasters?.length || 0}`}
                documentDetails={selectedDoc}
                type="view"
                embedMode
                onEmbedClose={onClose}
                showTrigger={false}
                showUpload={false}
                showDownloadMultiple={false}
                showArrows={true}
                latestStageDocuments={latestStageDocuments}
                setSelectedDocument={setSelectedDocument}
                handleMapDocument={handleMapDocument}
                queryView
                isReferenceSelected={isReferenceSelected}
              />
            ) : (
              <div className="flex justify-center items-center text-[24px] xl:text-[28px] 2xl:text-[38px] font-semibold h-full">
                No Document Present
              </div>
            )}
          </div>
        </div>
      </Box>
    </Modal>
  );
}
